export const environment = {
  production: false,
  apiUrl: 'https://portal-admin-api.dev.transferia.app/api',
};
